<template>
  <div id="wizardCard" class="card card-wizard">
    <!-- <app-modal absolute id="modal-movimientos" :title="modalTitle" :comp="modalComponent" :data="modalData" :size="modalSize" :scroll="modalScroll" :footer="false" :footerComp="modalFooterComp"></app-modal> -->
    <v-dialog v-model="intDialogVisible" transition="dialog-bottom-transition">
      <template v-slot:default="dialog">
        <v-card>
          <v-card-title>{{ modalTitle }}</v-card-title>

          <v-card-text class="border-top">
            <component :is="modalComponent" :data="modalData" :key="'tipo_dec' + modalData.id"></component>
          </v-card-text>
          <v-card-actions class="justify-end border-top">
            <v-btn text @click="dialog.value = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Consulta General </legend>
          </div>
          <div v-if="add_item">
            <div class="row">
              <h5 class="ml-3 mb-4">Acciones a realizar en: <strong>{{ form_item.nombres + " " + form_item.primer_apellido + ' ' + form_item.segundo_apellido }}</strong></h5>
            </div>
            <div class="row">
              <div class="form-group col-md-6" v-if="getKey('permisos').includes(17)">
                <label class="control-label">Seleccione el movimiento a realizar</label>
                <el-select clearable class="select-default" filterable placeholder="Selecciona una opción" v-model="tipo_mov">
                  <el-option v-for="option in selects.movimientos" class="select-default" :value="option.value" :label="option.label" :key="option.label">
                  </el-option>
                </el-select>
              </div>
              <div class="form-group col-md-6" v-else>
                <label class="control-label">Seleccione el movimiento a realizar</label>
                <el-select clearable class="select-default" filterable placeholder="Selecciona una opción" v-model="tipo_mov">
                  <el-option v-for="option in selects.movimientos2" class="select-default" :value="option.value" :label="option.label" :key="option.label">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="tipo_mov == 0">
              <div class="row">
                <legend>Seguro que desea desactivar este registro?</legend>
                <div class="form-group col-md-12">
                  <label class="control-label">Observaciones</label>
                  <textarea class="form-control" type="text" v-model=form_item.motivo v-validate="'required'" placeholder="Motivos/Observaciones"></textarea>
                  <small class="text-danger">
                    {{ getError('motivo') }}
                  </small>
                </div>
              </div>
            </div>
            <div v-if="tipo_mov == 2">
              <div class="row">
                <legend>Seguro que desea dar de baja este registro?</legend>
                <div class="form-group col-md-6">
                  <label class="control-label">Fecha de baja</label>
                  <div class="form-group">
                    <!-- <el-date-picker :picker-options="opciones" type="date" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha" name="fecha_termino" v-model="form_item.fecha_termino" v-validate="'required'">
                    </el-date-picker> -->
                    <el-date-picker  type="date" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha" name="fecha_termino" v-model="form_item.fecha_termino" v-validate="'required'">
                    </el-date-picker>
                  </div>
                  <small class="text-danger">
                    {{ getError('fecha_termino') }}
                  </small>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Tipo de baja</label>
                  <el-select clearable class="select-default" filterable name="tipo_baja" v-model=form_item.tipo_baja v-validate="'required'" placeholder="Selecciona una opción">
                    <el-option value="Normal">
                    </el-option>
                    <el-option value="Por defunción">
                    </el-option>
                  </el-select>
                  <small class="text-danger">
                    {{ getError('tipo_baja') }}
                  </small>
                </div>
              </div>
            </div>
            <div v-if="tipo_mov == 4">
              <div class="row">
                <legend> Crear licencia</legend>
                <div class="form-group col-md-6">
                  <label class="control-label">Fecha de inicio</label>
                  <div class="form-group">
                    <el-date-picker type="date" value-format="dd-MM-yyyy" format="dd-MM-yyyy" name="inicia" placeholder="Seleccione fecha" v-model=form_item.inicia v-validate="'required'">
                    </el-date-picker>
                    <small class="text-danger">
                      {{ getError('inicia') }}
                    </small>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Fecha de Fin</label>
                  <div class="form-group">
                    <el-date-picker type="date" value-format="dd-MM-yyyy" format="dd-MM-yyyy" name="termina" placeholder="Seleccione fecha" v-model=form_item.termina v-validate="'required'">
                    </el-date-picker>
                    <small class="text-danger">
                      {{ getError('termina') }}
                    </small>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Tipo de licencia</label>
                  <el-select clearable class="select-default" filterable name="tipo_licencia" v-model=form_item.tipo_licencia v-validate="'required'" placeholder="Selecciona una opción">
                    <el-option value="Médica">
                    </el-option>
                    <el-option value="Trabajo">
                    </el-option>
                  </el-select>
                  <small class="text-danger">{{ errors.first('ant_sub_12') }}</small>
                  <small class="text-danger">
                    {{ getError('tipo_licencia') }}
                  </small>
                </div>
                <div class="form-group col-md-12">
                  <label class="control-label">Observaciones</label>
                  <textarea class="form-control" type="text" name="motivo" v-model=form_item.motivo v-validate="'required'" placeholder="Motivos/Observaciones"></textarea>
                  <small class="text-danger">
                    {{ getError('motivo') }}
                  </small>
                </div>
              </div>
            </div>
            <div v-if="tipo_mov == 3">
              <div class="row">
                <legend> Crear Promoción</legend>
                <div class="form-group col-md-4">
                  <label class="control-label">Nombre(s)</label>
                  <input class="form-control" type="text" name="nombres" v-validate="'required'" v-model="form_item.nombres" readonly placeholder="Nombre(s)">
                  <small class="text-danger">
                    {{ getError('nombres') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Apellido Paterno</label>
                  <input class="form-control" type="text" name="primer_apellido" v-validate="'required'" v-model="form_item.primer_apellido" readonly placeholder="Especificar">
                  <small class="text-danger">
                    {{ getError('primer_apellido') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Apellido Materno</label>
                  <input class="form-control" type="text" name="segundo_apellido" v-model="form_item.segundo_apellido" readonly placeholder="Especificar">
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Cargo funcional</label>
                  <input class="form-control" type="text" name="direccion_cargo" v-validate="'required'" v-model="form_item.cargo" placeholder="Cargo">
                  <small class="text-danger" >
                    {{ getError('direccion_cargo') }}
                  </small>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Área de adscripción</label>
                  <input class="form-control" type="text" name="area_adscripcion" v-validate="'required'" v-model="form_item.area" placeholder="Área de adscripción">
                  <small class="text-danger">
                    {{ getError('area_adscripcion') }}
                  </small>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Nivel tabular</label>
                  <input class="form-control" type="text" name="nivel" v-validate="'required'" v-model="form_item.nivel" placeholder="Nivel tabular">
                  <small class="text-danger">
                    {{ getError('nivel') }}
                  </small>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Fecha de término del cargo anterior</label>
                  <div class="form-group">
                    <el-date-picker type="date" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha" name="fecha_termino" v-model="form_item.fecha_termino" v-validate="'required'">
                    </el-date-picker>
                    <small class="text-danger" >
                      {{ getError('fecha_termino') }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="tipo_mov == 5">
              <div class="row">

                <div class="form-group col-md-4">
                  <label class="control-label">Nombre(s)</label>
                  <input class="form-control" type="text" name="nombres" v-validate="'required'" v-model="form_item.nombres" placeholder="Nombre(s)">
                  <small class="text-danger">
                    {{ getError('nombres') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Apellido Paterno</label>
                  <input class="form-control" type="text" name="primer_apellido" v-validate="'required'" v-model="form_item.primer_apellido" placeholder="Especificar">
                  <small class="text-danger">
                    {{ getError('primer_apellido') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Apellido Materno</label>
                  <input class="form-control" type="text" name="segundo_apellido" v-model="form_item.segundo_apellido" placeholder="Especificar">
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">RFC</label>
                  <input class="form-control" type="text" name="rfc" v-validate="'required'" v-model="form_item.rfc" placeholder="RFC">
                  <small class="text-danger">
                    {{ getError('rfc') }}
                  </small>
                </div>

                <div class="form-group col-md-6">
                  <label class="control-label">CURP</label>
                  <input class="form-control" type="text" name="curp" v-validate="'required'" v-model="form_item.curp" placeholder="CURP">
                  <small class="text-danger">
                    {{ getError('curp') }}
                  </small>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label class="control-label">Dependencia</label>
                  <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" name="ente_publico_id" v-validate="'required'" v-model="form_item.ente_publico_id">
                    <el-option v-for="option in dependencias" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                  </el-select><small class="text-danger">
                    {{ getError('ente_publico_id') }}
                  </small>
                </div>

                <div class="form-group col-md-6">
                  <label class="control-label">
                    Correo Electrónico Laboral
                  </label>
                  <input class="form-control" type="text" name="correo_laboral" v-validate="'required'" v-model="form_item.correo_electronico_laboral" placeholder="Correo Laboral" />
                  <small class="text-danger">
                    {{ getError('correo_laboral') }}
                  </small>
                </div>

                <div class="form-group col-md-12">
                  <label class="control-label">Empleo, Cargo o Comisión</label>
                  <input class="form-control" type="text" name="direccion_cargo" v-validate="'required'" v-model="form_item.cargo" placeholder="Dirección">
                  <small class="text-danger">
                    {{ getError('direccion_cargo') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Contrato por honorarios</label>
                  <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" name="honorarios" v-validate="'required'" v-model="form_item.contratado_honorarios">
                    <el-option :value="1" label="Si"></el-option>
                    <el-option :value="2" label="No"></el-option>
                  </el-select><small class="text-danger">
                    {{ getError('honorarios') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Nivel del Encargo</label>
                  <input class="form-control" type="text" name="nivel" v-validate="'required'" v-model="form_item.nivel" placeholder="Nivel tabular">
                  <small class="text-danger">
                    {{ getError('nivel') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Área de adscripción</label>
                  <input class="form-control" type="text" name="area_adscripcion" v-validate="'required'" v-model="form_item.area" placeholder="Área de adscripción">
                  <small class="text-danger" >
                    {{ getError('area_adscripcion') }}
                  </small>
                </div>
                <div class="col-md-4 form-group">
                  <label class="control-label">
                    Fecha de toma de Posesión del empleo, cargo o comisión
                  </label>
                  <br>
                  <el-date-picker value-format="dd-MM-yyyy" format="dd-MM-yyyy" name="fecha_posesion" v-validate="'required'" v-model="form_item.fecha_posesion" :picker-options="opciones" type="date" placeholder="Selecciona">
                  </el-date-picker>
                  <small class="text-danger">
                    {{ getError('fecha_posesion') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">
                    Titular de la dependencia o entidad
                  </label>
                  <p-radio name="titular" v-model="form_item.titular" label="1">SI</p-radio>
                  <p-radio name="titular" v-model="form_item.titular" label="2">NO</p-radio>
                </div>

                <div class="form-group col-md-4">
                  <label class="control-label">
                    Tipo
                  </label>
                  <p-radio name="simp" v-model="form_item.simplificada" label="0">Completa</p-radio>
                  <p-radio name="simp" v-model="form_item.simplificada" label="1">Simplificada</p-radio>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label class="control-label">Motivo de corrección</label>
                  <textarea class="form-control" type="text" name="motivo" placeholder="Motivo de corrección" v-model="form_item.motivo" v-validate="'required'"></textarea>
                  <small class="text-danger">
                    {{ getError('motivo') }}
                  </small>
                </div>
              </div>
            </div>
            <div v-if="tipo_mov == 6">
              <div class="row">
                <legend> Modificar contraseña</legend>
                <div class="form-group col-md-6">
                  <label class="control-label">Contraseña</label>
                  <input class="form-control" type="password" name="Password" ref="Password" v-validate="'required|regex:^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$|min:8'" v-model="form_item.password" placeholder="*****">
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Confirmar contraseña</label>
                  <input class="form-control" type="password" name="Confirmar" v-validate="'required|confirmed:Password'" v-model="form_item.Confirmar" placeholder="*****">
                </div>
                <div class="alert alert-danger ml-3">
                  <div v-if="errors.has('Password')">
                    La contraseña debe ser alfanumérica y de 8 caracteres mínimo
                  </div>
                  <div v-if="errors.has('Confirmar')">
                    <span class="texto">Las contraseñas no coinciden</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="tipo_mov == 7">
              <div class="row">
                <legend> Eliminar del Padrón</legend>

              </div>
            </div>
            <div v-if="tipo_mov == 8">
              <div class="row">
                <div class="col-md-4 form-group">
                  <label class="control-label">
                    Hacer declaración publica
                  </label><br>
                  <p-radio name="honorarios" v-model="form_item.publica" label="1">SI</p-radio>
                  <p-radio name="honorarios" v-model="form_item.publica" label="2">NO</p-radio>

                </div>

              </div>
            </div>
            <div v-if="tipo_mov == 9">
              <div class="row">
                <div class="col-md-4 form-group">
                  <label class="control-label">
                    Justificar declaración
                  </label><br>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label class="control-label">Razón de justificación</label>
                  <textarea class="form-control" type="text" name="motivo" placeholder="Motivo de justificación" v-model="form_item.motivo" v-validate="'required'"></textarea>
                  <small class="text-danger">
                    {{ getError('motivo') }}
                  </small>
                </div>
              </div>
            </div>
            <!-- <div v-if="tipo_mov == 11">
              <div class="row">
                <legend>Transferencia</legend>
              </div>
              <div class="row">
                <div class="form-group col-6">
                  <label class="control-label">Dependencia origen</label>
                  <div>{{filterdepoendencia(form_item.ente_publico_id)}}</div>
                </div>

                <div class="form-group col-6">
                  <label class="control-label">Dependencia cambio</label>
                  <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" name="ente_cambo_id" v-validate="'required'" v-model="form_item.ente_cambo_id">
                    <el-option v-for="option in dependencias" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                  </el-select><small class="text-danger">
                    {{ getError('ente_publico_id') }}
                  </small>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label class="control-label">Motivo de trasnferencia</label>
                  <textarea class="form-control" type="text" name="motivo" placeholder="Motivo de trasnferencia" v-model="form_item.motivo" v-validate="'required'"></textarea>
                  <small class="text-danger">
                    {{ getError('motivo') }}
                  </small>
                </div>
              </div>
            </div> -->

            <div class="row justify-content-end m-3">
              <button class="btn btn-primary" @click.prevent="addItem()" v-if="tipo_mov">
                <span v-if="edit_item == null">
                  <i class="fa fa-plus"></i> Agregar
                </span>
                <span v-else>
                  <i class="fa fa-save"></i> Guardar
                </span>
              </button>
              <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
                <span>
                  <i class="fa fa-times"></i> Cancelar
                </span>
              </button>
            </div>

            <div class="row">
              <hr class="col-md-12 bg-info">
            </div>
          </div>
          <div v-if="!add_item">
            <div v-if="getKey('permisos').includes(17)">

              <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <p-radio class="d-inline-block" name="conest" v-model="tipobusqueda" label="1">Dependencia</p-radio>
                  <p-radio class="d-inline-block" name="conest" v-model="tipobusqueda" label="2">General</p-radio>
                </div>
                <div class="col-sm-6">
                  <export-excel v-if="list_declarantes2.length > 0" class="btn btn-wd btn-success pull-right" :data="list_declarantes2" :meta="meta" :fields="cumplidos_campos" worksheet="Padron" name="Padron.xls">
                    <span class="btn-label">
                      <i class="fa fa-file-excel"></i>
                    </span>
                    Descargar
                  </export-excel>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6" v-if="tipobusqueda == '2'">
                  <label>Buscar</label>
                  <input class="form-control" type="text" v-model="filter" placeholder="Buscar">
                  <small class="text-danger" v-if="busqueda">La búsqueda requiere un mínimo de 4 letras</small>
                  <!--  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="filter" placeholder="Búsqueda general" aria-label="Buscar:" aria-describedby="basic-addon2">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button" @click="itemsprovider">Buscar</button>
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="row" v-if="tipobusqueda == '1'">
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <label>Filtra por dependencia:</label>
                  <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" v-model="filtro" @change="traetodo" :disabled="isLoading">
                    <el-option v-for="option in dependencias" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                  </el-select>
                </div>
                <!-- <div class="col-sm-6 col-md-6 col-lg-6" v-if="filtrainici">
                  <label>Filtra por inicial de RFC</label>
                  <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" v-model="iniciales" @change="traeiniciales">
                    <el-option v-for="option in inicialeslst" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                  </el-select>
                </div> -->
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <label></label>
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="" class="busqueda" placeholder="Buscar RFC" clearable single-line  hide-details @click:clear="clearSearch" ></v-text-field>
                  <!-- <input class="form-control" type="text" v-model="search" placeholder="Buscar"> -->
                </div>
              </div>

            </div>
            <div class="row" v-if="!getKey('permisos').includes(17)">
              <!-- <div class="col-sm-6 col-md-6 col-lg-6" v-if="filtrainici">
                <label>Filtra por inicial de RFC</label>
                <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" v-model="iniciales" @change="traeiniciales">
                  <el-option v-for="option in inicialeslst" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                </el-select>
              </div> -->

              <div class="col-sm-6 col-md-6 col-lg-6">
                <label>Buscar</label>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="" class="busqueda" placeholder="Buscar RFC" clearable single-line  hide-details  @click:clear="clearSearch"></v-text-field>
                <!-- <input class="form-control" type="text" v-model="search" placeholder="Buscar"> -->
              </div>

              <div class="col-sm-12">
                <export-excel v-if="list_declarantes2.length > 0" class="btn btn-wd btn-success pull-right" :data="list_declarantes2" :meta="meta" :fields="cumplidos_campos" worksheet="Padron" name="Padron.xls">
                  <span class="btn-label">
                    <i class="fa fa-file-excel"></i>
                  </span>
                  Descargar
                </export-excel>
              </div>
            </div>
            <div class="row">

            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <!-- <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
                </v-text-field> :search="search" -->
                <v-data-table
                              :headers="headers"
                              :items="filtro_usuarios"
                              :footer-props="listSize"
                              :options.sync="pagination"
                              :server-items-length="totalItems"
                              @update:options="traetodo"
                              :loading="isLoading"
                              item-key="id"
                              :fixed-header="true"
                              hide-default-footer
                              class="">
                              <!-- :search="search" -->
                  <template v-slot:item.acciones="{ item }">
                    <div class="d-flex justify-content-center">
                      <b-button @click.prevent="showTipoDec(item)" v-b-popover.hover.top="'Tipo declaración'" class="btn-s edit mr-2" variant="warning" v-if="(rol == 1)">
                        <i class="fas fa-project-diagram"></i>
                      </b-button>

                      <b-button @click.prevent="restore(item)" v-b-popover.hover.top="'Reactivar usuario'" class="btn-s edit mr-2" variant="danger" :disable="(rol != 1)" v-if="item.fecha_termino != null">
                        <i class="fas fa-history"></i>
                      </b-button>
                      <b-button @click.prevent="editItem(item)" v-b-popover.hover.top="'Editar datos de usuario'" class="btn-s edit mr-2" variant="success" :disabled="(edit_item != null) || (item.fecha_termino != null)" v-if="item.fecha_termino == null">
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>

                      <b-button @click.prevent="resetpass(item)" v-b-popover.hover.top="'Resetear contraseña'" class="btn-s edit mr-2" variant="primary" v-if="getKey('permisos').includes(4)">
                        <i class="fas fa-key"></i>
                      </b-button>

                    </div>
                  </template>
                  <template v-slot:item.nombres="{ item }">
                    <div>{{ item.nombres + ' ' + item.primer_apellido + ' ' + item.segundo_apellido }} </div>
                  </template>
                  <template v-slot:item.ente="{ item }">
                    <div>{{ item.ente }}</div>
                  </template>
                  <template v-slot:item.area="{ item }">
                    <div>{{ item.area }}</div>
                  </template>
                  <template v-slot:item.cargo="{ item }">
                    <div>{{ item.cargo }}</div>
                  </template>
                  <template v-slot:item.nivel="{ item }">
                    <div>{{ item.nivel }}</div>
                  </template>
                  <template v-slot:item.simplificada="{ item }">
                    <div>{{ simplif(item.simplificada) }}</div>
                  </template>
                  <template v-slot:item.titular="{ item }">
                    <div>{{ titular(item.titular) }}</div>
                  </template>
                  <template v-slot:item.activo="{ item }">
                    <div>{{ activo(item.fecha_termino) }}</div>
                  </template>
                  <template v-slot:no-data>
                    <v-alert :value="true" :color="coloremp">
                      {{ txtemp }}
                    </v-alert>
                  </template>

                </v-data-table>
                <hr style="background: #e0e0e0; height: 1px !important;">
                <v-row>
                  <v-col cols="12" sm="12" xs="12" md="4" lg="4" xl="4" class="d-flex align-items-center">
                    Filas por página:
                    <v-select
                              v-model="pagination.itemsPerPage"
                              :items="listSize.itemsPerPageOptions"
                              hide-details
                              single-line
                              style="max-width: 50px;"
                              class=" p-0 m-0 ml-3"></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="8"  lg="8" xl="8">
                    <v-pagination
                                  v-model="pagination.page"
                                  :length="pagination.lastPage"
                                  :total-visible="7"
                                  @input="traetodo"
                                  class="my-4">
                    </v-pagination>
                  </v-col>

                </v-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import excel from 'vue-excel-export'
import swal from 'sweetalert2'
import {
  Select,
  Option,
  DatePicker
} from 'element-ui'
import {
  mapFields
} from 'vee-validate'

import Domicilio from '../Domicilio.vue'
import TipoDec from './TipoDec.component.vue'
import moment from 'moment'

Vue.use(Select)
Vue.use(Option)
Vue.use(excel)

export default {
  components: {
    [DatePicker.name]: DatePicker,
    TipoDec
  },
  props: ['data'],
  data () {
    return {
      opciones: {
        disabledDate (date) {
          return date > new Date()
        }
      },
      intDialogVisible: false,
      isLoading: false,
      encargo: {},
      filter: '',
      iniciales: '',
      movimiento: {},
      tipobusqueda: '1',
      // busquedarfc: '',
      meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ],
      // nombreC: '',
      coloremp: 'info',
      txtemp: 'Buscando',
      list_declarantes2: [],
      // text: 'Acciones',
      // align: 'center',
      // sortable: false,
      // value: 'acciones',
      // class: '',
      cumplidos_campos: {
        'RFC': 'rfc',
        'Nombres': 'nombres',
        'Dependencia': 'dependencia',
        'Área': 'area',
        'Cargo': 'cargo',
        'Nivel': 'nivel',
        'Tipo de Declaración': 'simplificada',
        'Titular': 'titular',
        'Activo': 'activo'
      },
      filtrainici: false,
      // tipo_declaracion: [{
      //   'id': 1,
      //   'valor': 'Inicial'
      // }, {
      //   'id': 2,
      //   'valor': 'Anual'
      // }, {
      //   'id': 3,
      //   'valor': 'Final'
      // }],
      // grupos: [{
      //   'id': 1,
      //   'valor': 'Grupo 1',
      //   'cve': 'g1'
      // }, {
      //   'id': 2,
      //   'valor': 'Grupo 2',
      //   'cve': 'g2'
      // }, {
      //   'id': 3,
      //   'valor': 'Grupo 3',
      //   'cve': 'g3'
      // }],
      inicialeslst: [{
        'id': 1,
        'valor': 'A-B',
        'cve': '1'
      }, {
        'id': 2,
        'valor': 'C-D',
        'cve': '2'
      }, {
        'id': 3,
        'valor': 'E-F',
        'cve': '3'
      }, {
        'id': 4,
        'valor': 'G-H',
        'cve': '4'
      }, {
        'id': 5,
        'valor': 'I-J',
        'cve': '5'
      }, {
        'id': 6,
        'valor': 'K-L',
        'cve': '1'
      }, {
        'id': 7,
        'valor': 'M-O',
        'cve': '2'
      }, {
        'id': 8,
        'valor': 'P-Q',
        'cve': '3'
      }, {
        'id': 9,
        'valor': 'R-S',
        'cve': '4'
      }, {
        'id': 10,
        'valor': 'T-U',
        'cve': '5'
      }, {
        'id': 11,
        'valor': 'V-W',
        'cve': '3'
      }, {
        'id': 12,
        'valor': 'X-Z',
        'cve': '4'
      }
        //  {
        //   'id': 13,
        //   'valor': 'X-Z',
        //   'cve': '5'
        // }
      ],
      currentPage: 1,
      perPage: 30,
      rol: '',
      id: 1,
      rows: null,
      add_item: false,
      edit_item: null,
      // tipos: null,
      // n_domicilio: null,
      // dependencias: null,
      filtro: '',
      // filtrorfc: '',
      tipo_mov: null,
      form_item: {},
      list_usuarios: [],
      filtro_usuarios: [],
      origen: {},
      // form_itemValidations: {
      //   rfc: {
      //     required: true
      //   },
      //   curp: {
      //     required: true
      //   },
      //   correo_laboral: {
      //     required: true
      //   },
      //   grupo: {
      //     required: true
      //   },
      //   nombres: {
      //     required: true
      //   },
      //   primer_apellido: {
      //     required: true
      //   },
      //   segundo_apellido: {
      //     required: true
      //   },
      //   ente_publico_id: {
      //     required: true
      //   },
      //   direccion_cargo: {
      //     required: true
      //   },
      //   nivel: {
      //     required: true
      //   },
      //   area_adscripcion: {
      //     required: true
      //   },
      //   honorarios: {
      //     required: true
      //   },
      //   AG172: {
      //     required: true
      //   },
      //   fecha_termino: {
      //     required: true
      //   },
      //   motivo: {
      //     required: true
      //   },
      //   tipo_baja: {
      //     required: true
      //   },
      //   inicia: {
      //     required: true
      //   },
      //   termina: {
      //     required: true
      //   },
      //   tipo_licencia: {
      //     required: true
      //   },
      //   fecha_posesion: {
      //     required: true
      //   },
      //   tipo_dec_id: {
      //     required: true
      //   }
      // },
      // campos_busqueda: ['rfc', 'nombres', 'primer_apellido', 'segundo_apellido'],
      // table_list: [],
      search: '',
      current_search: '',
      awaitingSearch: false,
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'ente',
        align: 'center'
      }, {
        text: 'Área',
        value: 'area',
        align: 'center'
      }, {
        text: 'Cargo Funcional',
        value: 'cargo',
        align: 'center'
      }, {
        text: 'Nivel',
        value: 'nivel',
        align: 'center'
      }, {
        text: 'Tipo de declaración',
        value: 'simplificada',
        align: 'center'
      },
      {
        text: 'Titular',
        value: 'titular',
        align: 'center'
      },
      {
        text: 'Activo',
        value: 'activo',
        align: 'center'
      }
      ],

      selects: {
        simple: '',
        movimientos: [{
          value: '0',
          label: 'Desactivar servidor'
        },
        {
          value: '2',
          label: 'Crear baja '
        },
        {
          value: '4',
          label: 'Crear licencia'
        },
        {
          value: '3',
          label: 'Crear promoción'
        },
        {
          value: '5',
          label: 'Realizar corrección'
        },
        {
          value: '6',
          label: 'Cambiar contraseña'
        },
        {
          value: '7',
          label: 'Eliminar del Padrón'
        },          /* ,
                      {
                        value: "8",
                        label: "Hacer Declaración Pública"
                      } */

        {
          value: '9',
          label: 'Justificar Declaración'
        }
        ],
        movimientos2: [{
          value: '2',
          label: 'Crear baja '
        },
        {
          value: '4',
          label: 'Crear licencia'
        },
        {
          value: '3',
          label: 'Crear promoción'
        },
        {
          value: '5',
          label: 'Realizar corrección'
        },
        {
          value: '6',
          label: 'Cambiar contraseña'
        }
          /* ,
                      {
                        value: "8",
                        label: "Hacer Declaración Pública"
                      } */
        ]
      },
      listSize: {
        itemsPerPageOptions: [10, 25, 50, 100]
      },
      pagination: {
        page: 1,
        itemsPerPage: 10,
        lastPage: null
      },
      totalItems: 0
    }
  },
  computed: {

    to () {
      let highBound = this.from + this.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.perPage * (this.currentPage - 1)
    },
    total () {
      // console.log(this.list_usuarios.length);
      this.rows = this.list_usuarios.length

      return this.list_usuarios.length
    },
    busqueda () {
      if (this.filter.length >= 1 && this.filter.length < 4) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    // busquedarfc: {
    //   handler: function () {
    //     this.filter = ''
    //     this.$refs.busqrfc.refresh()
    //   },
    //   deep: true
    // },
    tipobusqueda: {
      handler: function () {
        this.filter = ''
        this.search = ''
      },
      deep: true
    },
    filter (val) {
      this.coloremp = 'info'
      this.txtemp = 'Buscando...'
      if (val && val.length >= 4) {
        this.traetodo()
        // this.filtro_usuarios = []
        // this.$http.get('infpersonal/rfc/' + val).then(
        //   response => {
        //     this.filtro_usuarios = response.data.usuarios
        //     if (response.data.usuarios.length == 0) {
        //       this.coloremp = 'danger'
        //       this.txtemp = 'No encontrado'
        //     }
        //   },
        //   error => {
        //     this.Err(error)
        //
        //   }
        // )
      } else {
        this.filtro_usuarios = this.list_usuarios
      }
    },
    search (val) {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.traetodo()
          this.awaitingSearch = false
        }, 2000) // 1 sec delay
      }
      this.awaitingSearch = true
    },
    'form_item.titular': {
      handler: function () {
        if (this.form_item.encargo) {
          if (this.form_item.titular === '1') {
            this.$swal({
              title: 'Titular',
              showCancelButton: true,
              confirmButtonClass: 'btn btn-success btn-fill',
              cancelButtonClass: 'btn btn-danger btn-fill',
              confirmButtonText: 'SI',
              cancelButtonText: 'NO',
              html: '¿Deseas marcarlo como titular?',
              buttonsStyling: false
            }).then(function () {


            }).catch(e => {
              this.form_item.titular = '2'
            })
          } else {
            this.form_item.titular = '2'
          }
        }
      },
      deep: true
    },
    'form_item.simplificada': function (val) {
      if (val == '1') { this.form_item.grupo_id = 3 }
      // else
      //   this.form_item.grupo_id = 1;
    },
    'form_item.grupo_id': function (val) {
      if (val == 3) { this.form_item.simplificada = '1' } else { this.form_item.simplificada = '0' }
    }

  },

  methods: {
    async getEncargo (ip_id) {
      this.encargo = {
        titular: '2'
      }
      await this.$http.get('encargo/' + ip_id).then(
        response => {
          // console.log(response.data.informacion);
          this.encargo = response.data.informacion
        },
        error => {
          this.StepError(error)
          console.log(error)
        }
      )
    },
    showTipoDec (item) {
      this.intDialogVisible = true
      this.modalTitle = 'Lista de tipos de declaraciones'

      this.modalData = {
        ...item
      }
      this.modalComponent = TipoDec
      // this.modalScroll = true;
      // // this.showFooter = false;
      // this.modalSize = "modal-xl";
      // this.Modal("#modal-movimientos");
      // setTimeout(() => {
      //   $('#modal-movimientos').appendTo('body');
      // }, 1000);
    },
    simplif (val) {
      if (val == 1) { return 'SIMPLIFICADA' } else { return 'COMPLETA' }
    },
    titular (val) {
      if (val == 1) { return 'SI' } else { return 'NO' }
    },
    activo (val) {
      if (val) { return 'NO' } else { return 'SI' }
    },
    // traeiniciales () {
    //   this.coloremp = 'info'
    //   this.txtemp = 'Buscando...'
    //   this.filtro_usuarios = []
    //   this.list_declarantes2 = []
    //   let desde
    //   let hasta
    //   if (this.iniciales == 1) {
    //     desde = 'A'
    //     hasta = 'B'
    //   }
    //   if (this.iniciales == 2) {
    //     desde = 'C'
    //     hasta = 'D'
    //   }
    //   if (this.iniciales == 3) {
    //     desde = 'E'
    //     hasta = 'F'
    //   }
    //   if (this.iniciales == 4) {
    //     desde = 'G'
    //     hasta = 'H'
    //   }
    //   if (this.iniciales == 5) {
    //     desde = 'I'
    //     hasta = 'J'
    //   }
    //   if (this.iniciales == 6) {
    //     desde = 'K'
    //     hasta = 'L'
    //   }
    //   if (this.iniciales == 7) {
    //     desde = 'M'
    //     hasta = 'O'
    //   }
    //   if (this.iniciales == 8) {
    //     desde = 'P'
    //     hasta = 'Q'
    //   }
    //   if (this.iniciales == 9) {
    //     desde = 'R'
    //     hasta = 'S'
    //   }
    //   if (this.iniciales == 10) {
    //     desde = 'T'
    //     hasta = 'U'
    //   }
    //   if (this.iniciales == 11) {
    //     desde = 'V'
    //     hasta = 'W'
    //   }
    //   if (this.iniciales == 12) {
    //     desde = 'X'
    //     hasta = 'Z'
    //   }
    //   // if (this.iniciales == 13) {
    //   //   desde = 'X';
    //   //   hasta = 'Z'
    //   // }


    //   this.$http.get('infpersonal/limite/' + this.filtro + '/' + desde + '/' + hasta).then(
    //     response => {
    //       this.list_usuarios = response.data.usuarios

    //       this.filtro_usuarios = this.list_usuarios
    //       if (response.data.usuarios.length == 0) {
    //         this.coloremp = 'danger'
    //         this.txtemp = 'Sin resultados'
    //       } else {
    //         // let v = this
    //         response.data.usuarios.forEach((value, key) => {
    //           // $.each(response.data.usuarios, function (key, value) {
    //           // console.log(value.ente);
    //           this.list_declarantes2.push({
    //             'rfc': value.rfc,
    //             'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
    //             'dependencia': value.ente,
    //             'area': value.area,
    //             'cargo': value.cargo,
    //             'nivel': value.nivel,
    //             'simplificada': this.simplif(value.simplificada),
    //             'titular': this.titular(value.titular),
    //             'activo': this.activo(value.fecha_termino)
    //             // 'tipo_baja': value.movimientos.tipo_baja
    //           })
    //         })
    //       }
    //     },
    //     error => {
    //       this.Err(error)
    //     }
    //   )
    // },
    clearSearch () {
      this.search = ''
      this.traetodo()
    },
    traetodo (rfc_g = null) {
      this.coloremp = 'info'
      this.txtemp = 'Buscando...'
      this.filtrainici = false
      this.isLoading = true
      this.filtro_usuarios = []
      this.list_declarantes2 = []
      let dec = 0
      // dec = this.getServid(this.filtro)

      let page = this.pagination.page
      let ente = this.filtro
      let rfc_ = ''

      if (this.current_search !== this.search) {
        this.current_search = this.search
        page = 1
      }

      if (this.search && this.search.length >= 4) {
        rfc_ = this.search
      }

      if (this.filter) {
        ente = null
        rfc_ = this.filter
      }

      var params = {
        params: {
          page: page,
          itemsPerPage: this.pagination.itemsPerPage,
          filters: {
            ente: ente,
            rfc: rfc_
          }
        }
      }

      this.$http.get('infpersonal/usuarios/', params).then(
        response => {
          var lista = response.data
          // this.list_usuarios = response.data.data
          this.list_usuarios = [...lista.data]

          this.filtro_usuarios = this.list_usuarios
          this.isLoading = false

          this.totalItems = Number(response.data.total)
          this.pagination.page = Number(response.data.current_page)
          this.pagination.lastPage = Number(response.data.last_page)

          if (lista.data.length == 0) {
            this.coloremp = 'danger'
            this.txtemp = 'Sin resultados'
          } else {
            lista.data.forEach((value, key) => {
              this.list_declarantes2.push({
                'rfc': value.rfc,
                'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'dependencia': value.ente,
                'area': value.area,
                'cargo': value.cargo,
                'nivel': value.nivel,
                'simplificada': this.simplif(value.simplificada),
                'titular': this.titular(value.titular),
                'activo': this.activo(value.fecha_termino)
              })
            })
          }
        },
        error => {
          this.isLoading = false
          this.Err(error)
        }
      )
    },
    initItem () {
      this.tipo_mov = null
      this.form_item = {
        acciones: '',
        nombres: '',
        Paterno: '',
        Materno: '',
        User: '',
        Password: '',
        motivo: '',
        titular: '2',
        encargo: {
          titular: '2'
        }
      }
    },
    showItem () {
      this.add_item = true
      this.$validator.resume()
    },

    cancelEdit () {
      this.add_item = false
      this.origen = {}
      this.initItem()
      // this.form_item = {};
      this.edit_item = null
      this.$validator.pause()
    },

    addItem () {
      if (this.tipo_mov === '7') {
        this.Ask('¿Estás seguro de eliminarlo?', () => {
          this.$http.delete('infpersonal/' + this.edit_item.id).then(
            response => {
              if (response.data.declarante) {
                this.StepOk('eliminado')
                this.edit_item = null
                // this.filtrorfc = ''
                this.search = ''
                this.traetodo()
                this.cancelEdit()
              } else {
                this.StepW('El declarante no puede ser eliminado, ya que ya presentó su declaración patrimonial')
              }
            },
            error => {
              this.StepW(error + '-uno')
              // this.Err(error)
            }
          )
        })
      } else {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              // this.form_item.ip_id =
              this.loadButton(this.$refs.btnSave)
              this.form_item.tipo_mov = this.tipo_mov
              // this.cambio = this.origenCambio();
              this.form_item.origen = this.origen
              this.form_item.cambio = this.origenCambio()

              // console.log(this.form_item);

              this.$http.post('servidores', this.form_item).then(
                response => {
                  if (response.data.message) {
                    this.OK(response.data.message)
                  } else {
                    this.StepOk('Guardado')
                  }
                  // if (!this.edit_item) {
                  //   this.list_usuarios.unshift({
                  //     ...response.data.response
                  //   })
                  // } else {
                  //   // this.cancelEdit()

                  //   this.filtro_usuarios = this.list_usuarios
                  // }

                  this.initItem()
                  this.traetodo()
                  this.showItem()
                  this.cancelEdit()
                  this.edit_item = null
                },
                error => {
                  // this.StepW(error)
                  this.StepError(error)
                  // this.change =  true;
                }
              )
            }
          } else {
            this.StepW('Hay campos sin completar')
          }
        })
      }

      // console.log(this.item_empresas);
    },
    editItem (indice, i) {
      this.showItem()
      this.edit_item = indice

      if (!this.edit_item.encargo) {
        this.edit_item.encargo = {
          titular: '2'
        }
      }

      // console.log(this.edit_item);
      this.form_item = {
        ...this.edit_item
      }

      this.form_item.fecha_posesion = moment(String(this.form_item.fecha_posesion)).format('DD-MM-YYYY')

      this.getEncargo(indice.id).then((result) => {
        this.form_item.encargo = this.encargo
      })
      // console.log(this.form_item.grupo_id);
      this.origen = this.origenCambio()
      // console.log(this.origen);
      this.form_item.password = ''
      // this.edit_item.item._rowVariant = "danger";
      $('.main-panel').animate({
        scrollTop: 100
      },
        500,
        'swing'
      )
    },
    restore (item) {
      this.AskMessage('¿Desea la reactivación de este usuario?', 'Observaciones: ', 'Reactivar', (msg) => {
        // var obj = {
        //   id: item.id,
        //   observaciones: msg
        // }

        var params = {
          params: {
            id: item.id,
            observaciones: msg
          }
        }
        this.$http.get('cancelarbaja', params).then(response => {
          this.traetodo()
          this.StepOk('Usuario reactivado')
        },
          error => {
            this.Err(error)
          }
        )
      })
    },
    resetpass (item) {
      this.Ask('¿Desea restablecer la contraseña de este usuario?', () => {
        this.$http.post('infpersonal/resetpass', item).then(
          response => {
            //  console.log(item);
            this.StepOk('Contraseña actualizada')
          },
          error => {
            this.Err(error)
          }
        )
      })
    },
    origenCambio () {
      var o = {
        rfc: this.form_item.rfc,
        curp: this.form_item.curp,
        grupo_id: this.form_item.grupo_id,
        correo_electronico_laboral: this.form_item.correo_electronico_laboral,
        nombres: this.form_item.nombres,
        primer_apellido: this.form_item.primer_apellido,
        segundo_apellido: this.form_item.segundo_apellido,
        dependencia: this.form_item.ente_publico_id,
        cargo: this.form_item.cargo,
        honorarios: this.form_item.contratado_honorarios,
        nivel: this.form_item.nivel,
        area: this.form_item.area,
        titular: this.form_item.titular,
        fecha_posesion: this.form_item.fecha_posesion,
        simplificada: this.form_item.simplificada,
        tipo_dec_id: this.form_item.tipo_dec_id
      }
      return o
    },

    getError (fieldName) {
      return this.errors.first(fieldName)
    }
    // getServid (index) {
    //   let a = 0
    //   if (this.dependencias) {
    //     this.dependencias.forEach(function (item) {
    //       if (item.id == index) {
    //         a = item.declarantes_count
    //       }
    //     })
    //   }
    //   return a
    // }
    // filterdepoendencia (id) {
    //   var resp = ' '
    //   if (this.dependencias) {
    //     this.dependencias.forEach(function (item) {
    //       if (item.id == id) {
    //         resp = item.valor
    //         return resp
    //       }
    //     })
    //   }
    //   return resp
    // }
  },
  created () {
    this.initItem()
    this.filtro = this.getKey('ente_publico_id')
    this.rol = this.getKey('role')

    if (this.rol == 1) {
      this.selects.movimientos.push({
        value: '11',
        label: 'Transferencia'
      })
    }

    // this.$http.get('cat/dec').then(
    //   response => {
    //     this.dependencias = response.data.entes_publicos
    //     this.traetodo()
    //   },
    //   error => {
    //     this.Err(error)
    //   }
    // )
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>

<style>
input[type="text"] {
  background: #F3F2EE !important;
  border-bottom: none !important;
}

.busqueda input[type="text"] {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Movimientos/Movimientos.vue